const { Cycler } = window.BAO

class SizeGuide extends window.BAO.CustomElement() {
  CURRENT_SIZE_ATTRIBUTE = 'current-size'
  ALLOWED_SIZES = ['in', 'cm']
  CLASSES = {
    in: 'drw-SizeGuide-in',
    cm: 'drw-SizeGuide-cm',
  }

  connectedCallback () {
    this.handleTriggerClick = this.handleTriggerClick.bind(this)
    this.cycler = new Cycler(this.ALLOWED_SIZES)
    this.cycler.set(this.cycler.items.findIndex((i) => i === this.currentSize))

    this.els.trigger?.element.addEventListener(
      'click',
      this.handleTriggerClick,
      {
        passive: true,
      },
    )
  }

  disconnectedCallback () {
    this.els.trigger?.element.removeEventListener(
      'click',
      this.handleTriggerClick,
    )
  }

  async handleTriggerClick () {
    const currentSize = this.cycler.next()

    this.setCartAttribute(currentSize)
    this.currentSize = currentSize
    this.syncThemeSwitchers(currentSize)

    window.BAO.eventBus.dispatchEvent(window.BAO.EVENTS.THEME_SWITCH, {
      currentSize,
    })

    if (currentSize === 'cm') {
      this.els.integer.elements.forEach((integerEl) => {
        integerEl.innerText = integerEl.dataset.integer
      })
    } else {
      this.els.integer.elements.forEach((integerEl) => {
        const cmValues = integerEl.dataset.integer.split('-')
        const inValues = cmValues.map((cmValue) => {
          const inValue = (Number(cmValue) / 2.54).toFixed(1)
          if (inValue > 58) {
            return this.inchesToFeetAndInches(inValue)
          } else {
            return `${inValue}"`
          }
        })

        integerEl.innerText = inValues.join(' - ')
      })
    }
  }

  inchesToFeetAndInches (inches) {
    const totalInches = Math.round(inches)
    const feet = Math.floor(totalInches / 12)
    const remainingInches = totalInches % 12

    if (feet === 0) {
      return `${remainingInches}"`
    }

    return `${feet}'${remainingInches}"`
  }

  syncThemeSwitchers (currentSize) {
    this.allOtherThemeSwitches.forEach((el) => {
      el.currentSize = currentSize
      el.cycler.next()
    })
  }

  setCartAttribute (size) {
    // eslint-disable-next-line compat/compat
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          current_size: size,
        },
      }),
    })
  }

  get currentSize () {
    return (
      this.getAttribute(this.CURRENT_SIZE_ATTRIBUTE) || this.ALLOWED_SIZES[0]
    )
  }

  set currentSize (value) {
    this.setAttribute(this.CURRENT_SIZE_ATTRIBUTE, value)

    this.classList.toggle(this.CLASSES.in, value === 'in')
    this.classList.toggle(this.CLASSES.cm, value === 'cm')
  }

  get allOtherThemeSwitches () {
    // eslint-disable-next-line compat/compat
    return Array.from(document.querySelectorAll(this.localName)).filter(
      (el) => el !== this,
    )
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
